import { useState } from 'react';
import { WEAPONS } from '../game/weapons';

interface Props {
  onConfirm: (weaponId: string) => void;
  onBack: () => void;
}

export default function WeaponSelect({ onConfirm, onBack }: Props) {
  const [selected, setSelected] = useState(WEAPONS[0].id);

  return (
    <div className="screen">
      <div className="arcade-subtitle">Choose Your Weapon</div>
      <div className="panel" style={{ width: 460 }}>
        <div className="weapon-list">
          {WEAPONS.map((w) => (
            <div
              key={w.id}
              className={`weapon-card ${selected === w.id ? 'selected' : ''}`}
              onClick={() => setSelected(w.id)}
            >
              <div>
                <div className="weapon-name">{w.name}</div>
                <div className="weapon-category">{w.category}</div>
              </div>
              <div className="weapon-stats">
                <span>DMG {w.damage}</span>
                <span>MAG {w.magazineSize}</span>
                <span>{w.pelletsPerShot > 1 ? `${w.pelletsPerShot}x PELLET` : `RATE ${Math.round(1000 / w.fireIntervalMs)}/s`}</span>
              </div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 20, justifyContent: 'center' }}>
          <button className="arcade-btn secondary" onClick={onBack}>
            Back
          </button>
          <button className="arcade-btn" onClick={() => onConfirm(selected)}>
            Drop In
          </button>
        </div>
      </div>
    </div>
  );
}
